import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Basic' },
    { value: 1, label: 'Plus' },
    { value: 2, label: 'Book' },
  ],
});
